module.exports = __webpack_public_path__ + "static/media/1set.7eb0ca58.png";